<div class="header">
    <h3>Home</h3>
</div>

<fieldset>
    <legend>Welcome to BDO Measure</legend>
    <div class="mt-3">
        <p>
            BDO Measure is the Internal Inspection Program's (IIP) central tool for conducting internal inspections. BDO Measure supports you, the inspector, by housing the Engagement Review Questionnaire (ERQ), providing access to important inspection-related documents, and highlighting key deadlines and action items for upcoming inspections. It is designed to help you navigate the inspection process efficiently, consistently, and with the information you need in one place.
        </p>
        <p>
            BDO Measure supports the broader purpose of the IIP by promoting audit quality and compliance through an objective inspection process. As you complete your review of the audit file, evaluate engagements based on applicable professional standards, firm methodology, regulatory requirements, and the facts and circumstances of each engagement. The goal of the IIP is not to find fault, but to support continuous learning for both the engagement team and the inspection team.
        </p>
    </div>
    <div class="row mt-3">
        @if (showInspectorLinks) {
            <div class="col-12" [class.col-md-6]="showTeamCaptainLinks">
                <p class="mb-2"><b>Helpful Links for Inspectors</b></p>
                <ul class="mb-0 list-unstyled">
                    <li><a href="https://bdo4.sharepoint.com/:f:/s/AQC/IgAlPP_JZDNHTbmKt2GTPknTAZOKMGfJulC9oyuzUILw1ks?e=C0uHvW">Inspector Toolkit</a></li>
                    <li><a href="https://bdo4.sharepoint.com/:f:/s/AQC/IgCG4lnehGlxT5vYGJKCE3JAAeV0HYLPepcVUksB9MIwUGw?e=5T4biz">PCAOB Spotlights and Audit Focus Releases</a></li>
                    <li><a href="https://learning-emps.bdo.com/">BDOU</a></li>
                    <li><a href="https://ai.bdo.com/">Chat BDO</a></li>
                    <li><a href="https://bdo4.sharepoint.com/:b:/s/AQC/IQBaERdzdHMKTqo0vb4ykak9AeOviNuR_SwGhxMZGqzWBlQ?e=oKVNyA">ICF Practice Aid</a></li>
                </ul>
            </div>
        }
        @if (showTeamCaptainLinks) {
            <div class="col-12 mt-3 mt-md-0" [class.col-md-6]="showInspectorLinks">
                <p class="mb-2"><b>Helpful Links for Team Captain</b></p>
                <ul class="mb-0 list-unstyled">
                    <li><a href="https://bdo4.sharepoint.com/:f:/s/AQC/IgAM2qKLOMQ0SrEg-ce6ijuZAe9hKFyYu_JPYTPqRzpGgs4?e=ad2fOg">Team Captain Toolkit</a></li>
                    <li><a href="https://learning-emps.bdo.com/">BDOU</a></li>
                    <li><a href="https://ai.bdo.com/modules/chatbdo/p/chatsession?PersonaId=ecca3bfc-6a74-4a3b-daf7-08dd4ae42ede">Lucy</a></li>
                    <li><a href="https://bdo4.sharepoint.com/:b:/s/AQC/IQCPmAkLIkGgSLRCVXj7PXtQAa0FQdF02Uhu5rVEWXFrHtA?e=gJfRoB">ICF Persona User Guide - Lucy.pdf</a></li>
                    <li><a href="https://ai.bdo.com/">Chat BDO</a></li>
                    <li><a href="https://bdo4.sharepoint.com/:f:/r/sites/AQC/2026EngInspections/Shared%20Documents/PCAOB%20Inspections/!%20Inspection%20Support%20Team%20Resources/Root%20Cause%20Decision%20Tree%20files?csf=1&web=1&e=eyknQH">Root Cause Decision Tree Files</a></li>
                    <li><a href="https://bdo4.sharepoint.com/:b:/s/AQC/IQBaERdzdHMKTqo0vb4ykak9AeOviNuR_SwGhxMZGqzWBlQ?e=oKVNyA">ICF Practice Aid</a></li>
                    <li><a href="https://bdo4.sharepoint.com/:f:/s/AQC/IgCG4lnehGlxT5vYGJKCE3JAAeV0HYLPepcVUksB9MIwUGw?e=5T4biz">PCAOB Spotlights and Audit Focus Releases</a></li>
                </ul>
            </div>
        }
    </div>
</fieldset>

<fieldset class="mt-3">
    <legend>My Open Action Items</legend>
    <table class="table table-striped table-align-middle my-2">
        <thead>
            <tr class="headers-row">
                <th style="width: 8rem;">Engagement Code</th>
                <th style="min-width: 14rem;">Engagement Name</th>
                <th style="width: 12rem;">Fieldwork Start Date</th>
                <th style="width: 12rem;">Closing Meeting Date</th>
            </tr>
        </thead>
        <tbody>
            @if (isLoadingActionItems) {
                <tr>
                    <td colspan="4">
                        <span class="d-block p-2 text-center">
                            <i class="fa fa-spin fa-refresh text-primary"></i> Please wait while we load your action items&hellip;
                        </span>
                    </td>
                </tr>
            }
            @if (!isLoadingActionItems && actionItems.length === 0) {
                <tr>
                    <td colspan="4">
                        <span class="d-block p-2 text-center">
                            <i class="fa fa-ban text-danger"></i> No data to display&hellip;
                        </span>
                    </td>
                </tr>
            }
            @for (item of actionItems; track item.engagementId) {
                <tr>
                    <td class="text-nowrap">
                        <a [routerLink]="['/my-assignments', 'inspection']" [queryParams]="{ id: item.engagementId }">
                            {{item.engagementCode}}
                        </a>
                    </td>
                    <td>
                        <a [routerLink]="['/my-assignments', 'inspection']" [queryParams]="{ id: item.engagementId }">
                            {{item.engagementClient}}
                        </a>
                    </td>
                    <td [class.action-item-due-soon]="isDateDueSoon(item.startOfInspectionFieldWork)">
                        {{item.startOfInspectionFieldWork ? (item.startOfInspectionFieldWork | date : 'shortDate') : '---'}}
                    </td>
                    <td [class.action-item-due-soon]="isDateDueSoon(item.endOfInspectionFieldWork)">
                        {{item.endOfInspectionFieldWork ? (item.endOfInspectionFieldWork | date : 'shortDate') : '---'}}
                    </td>
                </tr>
            }
        </tbody>
    </table>
</fieldset>
